module.exports = __webpack_public_path__ + "static/media/social_fb_blue.db0abd18.svg";